import React, { useEffect } from "react";
import s from "./NewsDetails.module.scss";
import Header from "../../components/Header/Header";
import Footer from "../../components/Footer/Footer";
import { useParams } from "react-router-dom";
import useWindowDimensions from "../../components/WindowDimensions/WindowDimensions";
import MobileHeader from "../../components/MobileHeader/MobileHeader";
import ScrollToTop from "../../components/ScrollToTop/ScrollToTop";
import { useDispatch, useSelector } from "react-redux";
import { useTranslation } from "react-i18next";
import { getNewsDetails } from "../../redux/ApplicationSlice";
import { Carousel } from "react-responsive-carousel";

const NewsDetails = () => {
  const { width } = useWindowDimensions();
  // const news = data.find(it => it.id === Number(params.id))
  const news = useSelector((state) => state.application.newsDetails);
  const { t } = useTranslation();
  const dispatch = useDispatch();
  const params = useParams();

  const styleObj = {
    lineHeight: 4,
    lineSpacingMultiplier: "2",
    letterSpacing: "1px",
  };

  useEffect(() => {
    dispatch(getNewsDetails(params.id));
  }, [dispatch, params.id]);

  return (
    <div className={s.news_details}>
      {width > 970 ? <Header /> : <MobileHeader />}
      <div className={s.news_content}>
        <Carousel
          showThumbs={true}
          showStatus={false}
          autoPlay={true}
          thumbWidth={120}
          thumbHeight={40}
          className="news-carousel"
        >
          {news?.photos?.map((it) => (
            <div>
              <img src={it.image} className={s.img} />
            </div>
          ))}
        </Carousel>

        <div className={s.news_category}>
          <div>{t("news").toUpperCase()}</div>{" "}
        </div>
        <div className={s.news_title}>{news?.title}</div>
        <div className={s.news_date}>{news?.created_at}</div>

        <div
          className={s.news_description}
          dangerouslySetInnerHTML={{ __html: news?.body }}
          style={styleObj}
        ></div>
      </div>
      <Footer />
      <ScrollToTop />
    </div>
  );
};

export default NewsDetails;
